import { type NPC } from 'src/types'

export const NPCs: NPC[] = [
  {
    ap: 4,
    str: 4,
    vit: 1,
    dex: 1,
    createdAt: 1679175112102,
    hp: 8,
    id: 'yourself',
    actions: [
      'self reflection',
      'harmful behaviour'
    ],
    isVerified: false
  },
  {
    ap: 6,
    str: 1,
    vit: 1,
    dex: 1,
    createdAt: 1679175090068,
    hp: 4,
    id: 'taxman',
    actions: [
      'audit',
      'attack'
    ],
    isVerified: false
  },
  {
    ap: 4,
    str: 4,
    vit: 2,
    dex: 2,
    createdAt: 1679175104082,
    hp: 6,
    id: 'thug',
    actions: [
      'attack'
    ],
    isVerified: false
  },
  {
    ap: 4,
    str: 4,
    vit: 8,
    dex: 1,
    createdAt: 1679241124429,
    hp: 8,
    id: 'bear',
    actions: [
      'attack'
    ],
    isVerified: false
  },
  {
    ap: 2,
    vit: 2,
    str: 2,
    dex: 1,
    createdAt: 1679232189625,
    hp: 8,
    id: 'ludwig',
    actions: [
      'attack',
      'cry',
      'scream'
    ],
    isVerified: false
  },
  {
    ap: 4,
    vit: 1,
    str: 3,
    dex: 2,
    createdAt: 1679509248939,
    hp: 4,
    id: 'wolf',
    actions: [
      'attack',
      'howl'
    ],
    isVerified: false
  },
  {
    ap: 1,
    vit: 10,
    str: 1,
    dex: 1,
    createdAt: 1679179689105,
    hp: 10,
    id: 'tortoise',
    actions: [
      'attack'
    ],
    isVerified: false
  },
  // === NEW MISSING NPCS === //
  {
    ap: 8,
    str: 8,
    vit: 6,
    dex: 4,
    createdAt: Date.now(),
    hp: 25,
    id: 'wanderer',
    actions: [
      'attack',
      'meditate',
      'teleport'
    ],
    isVerified: false
  },
  {
    ap: 6,
    str: 5,
    vit: 3,
    dex: 8,
    createdAt: Date.now(),
    hp: 18,
    id: 'coyotes',
    actions: [
      'attack',
      'pack_tactics',
      'howl'
    ],
    isVerified: false
  }
]

// Export removed - now using named export above
